import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/cool/',
  headTitle: 'Free Cool Text Fonts',
  headDescription:
    'Picsart offers a free cool font generator to help you transform your social media, web page, or document content easily and in seconds.',
  heading: 'Cool Text Fonts to Impress Friends and Followers',
  description:
    'Use our cool text generator to transform your text and create your own unique aesthetic.',
  selectedCategory: FontCategory.Cool,
  inputPlaceholder: 'Write to see your cool fonts…',
  landingText: {
    imageSection: [
      {
        imgSrc: 'https://cdn140.picsart.com/03631050688904306307.webp',
        imgAlt: 'cool text fonts',
        imageWidth: 355,
        imageRight: false,
        title: 'Why do you need a cool text generator?',
        children: {
          paragraph: `Whether you are posting viral content on social media or trying to create an eye-catching web page for yourself or your brand, cool text fonts and <a className='link--underline' href='https://picsart.com/fonts/?style=Cool/' target='_blank'>cool font styles</a> can grab any viewer’s attention. Cool text fonts often have creative or stylistic designs that clearly stand out from standard fonts like Arial or Calibri, and Picsart offers a cool font generator with a variety of unique fonts that can help you transform your text with ease. All you need to do is copy and paste the text you want to transform, and the Picsart cool font generator can convert it for you in moments, so you can create your own aesthetic or grab viewer attention with ease.`,
        },
      },
      {
        imgSrc: 'https://cdn140.picsart.com/06350059335479530960.webp',
        imgAlt: 'cool text generator',
        imageWidth: 253,
        imageRight: true,
        title: 'Why should you use the Picsart cool font generator?',
        children: {
          paragraph:
            'Picsart can help you transform your content with cool text fonts with all the tools you need in a cool text generator:',
          list: [
            'All you need to do is copy and paste the text you want to convert, choose your font, and then copy and paste your converted text to your page or app of choice. It’s that easy.',
            'The Picsart cool text generator is completely free to use, and requires no registration. No annoying advertisements to deal with either!',
            'Choose from an array of cool text fonts for any occasion or style, such as Handwrite, Parenthesis, Arabic, Mix1, Mix2, and much more.',
            'The Picsart cool font generator works with all common browsers, making it easy to use on any device.',
          ],
        },
      },
    ],
    howToSection: {
      title: 'How to use the cool text generator',
      steps: [
        {
          title: 'Copy & paste your text',
          description:
            'Simply copy the text block you want to convert into the cool text generator tool to get started.',
        },
        {
          title: 'Choose from cool text fonts',
          description:
            'Browse our variety of cool text fonts to see your text block converted and find the perfect choice for your aesthetic.',
        },
        {
          title: 'Copy your converted text',
          description:
            'Once you found the cool text font for you, simply copy your converted text out of the tool into your app, web page, or document and you’re done!',
        },
      ],
      cta: 'Get Started!',
    },
    similarTools: {
      paragraph:
        ' Looking for similar text converting and editing tools like the cool font generator? Picsart offers all the free text tools you need for any purpose.',
    },
    moreInfo: {
      title: 'Need some more info?',
      description: 'Picsarts friendly support team will be happy to help.',
      btn: 'Get in touch',
    },
  },
};

export default props;
